import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import React, { FC } from 'react';
import './SubstitutionWidgetSkeleton.scss';

export const SubstitutionWidgetSkeleton: FC = () => {
  return (
    <div className="flex flex-col gap-3 substitutionWidgetSkeleton">
      {/* Day header skeleton */}
      <Skeleton className="mb-1">
        <SkeletonItem size={20} className="substitutionWidgetSkeleton__dayTitle" />
      </Skeleton>

      {/* Entry skeletons */}
      {[1, 2].map(index => (
        <div key={index} className="flex gap-4">
          <div className="flex flex-col substitutionWidgetSkeleton__time">
            <Skeleton>
              <SkeletonItem size={12} className="substitutionWidgetSkeleton__period" />
              <SkeletonItem size={12} className="substitutionWidgetSkeleton__timeRange" />
            </Skeleton>
          </div>
          <Skeleton className="flex-1 substitutionWidgetSkeleton__card">
            <div className="flex flex-col gap-2">
              <SkeletonItem size={16} className="substitutionWidgetSkeleton__subject" />
              <div className="flex gap-1">
                <SkeletonItem size={12} className="substitutionWidgetSkeleton__badge" />
              </div>
              <SkeletonItem size={12} className="substitutionWidgetSkeleton__info" />
              <SkeletonItem size={12} className="substitutionWidgetSkeleton__info" />
              <SkeletonItem size={12} className="substitutionWidgetSkeleton__info" />
            </div>
          </Skeleton>
        </div>
      ))}
    </div>
  );
};
